import { create } from "zustand";

const defaultSteps = [
    {
        id: "external-codes",
        title: "External codes",
        description: "",
        isPrepared: false,
    },
];

interface ExternalCodesState {
    steps: typeof defaultSteps;
    setSteps: (steps: any) => void;

    resetExternalCodesData: () => void;
}

export const useExternalCodesStore = create<ExternalCodesState>(set => ({
    steps: defaultSteps,
    setSteps: steps => set({ steps }),

    resetExternalCodesData: () =>
        set({
            steps: defaultSteps,
        }),
}));
